import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";
import { SearchBox } from "@components";
import { EmployeeListTableColumn } from "./EmployeeListTableColumn";

import { useEmployees } from "@hooks/inventory/employee/useEmployees";

import { EmployeesResponseType } from "@type/inventory/employee";
import { Pagination } from "@type/inventory/pagination";

import { TablePagination } from "@helpers/tablePagination";

export default function EmployeeListTable() {
  const { t } = useTranslation();
  const { control } = useForm();

  const { handleQuery, employeesState } = useEmployees();
  const { getData } = employeesState;

  const { data, pagination } = getData || ({} as EmployeesResponseType);
  const { total } = pagination || ({} as Pagination);

  return (
    <Table
      header={{
        title: t("INVENTORY_EMPLOYEE.EMPLOYEE.EMPLOYEE_TABLE.HEADER"),
        badge: {
          label: `${total || 0}`,
          size: "sm",
          type: "primary",
        },

        buttons: [
          <SearchBox
            key="search"
            control={control}
            handleQuery={handleQuery}
          />,
        ],
      }}
      columns={EmployeeListTableColumn(t)}
      rows={data?.map((item: any) => {
        return {
          ...item,
          mobileNumber: item.employee.mobileNumber,
          email: item.employee.email,
        };
      })}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
}
